// extracted by mini-css-extract-plugin
export default {"navButtonWrapper":"Navbutton_navButtonWrapper__2olfK"};